import React, { useEffect } from 'react'
import RealEstateProjects from '../Components/Projects'
const Projectspage = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to top when component loads
      }, []);
  return (
    <div className='py-24'>
      <RealEstateProjects/>
    </div>
  )
}

export default Projectspage
